export default "__VITE_ASSET__DDNYF2qK__"